import { html, TemplateResult, CSSResultGroup } from 'lit';
import { customElement } from 'lit/decorators.js';
import { OutlineElement } from '../../base/outline-element/outline-element';
import { SlotsNGController as SlotsController } from '../../controllers/slots-ng-controller';

import componentStyles from './sic-rate-table.css.lit';

/**
 * Annuity Product Rate Table component
 * This gets consumed by the wrapper component
 * @slot heading
 * @slot caption
 * @slot table
 *
 * Lightdom styles in sic-rate-table.lightdom.css included in /shared.css
 */

@customElement('sic-rate-table')
export class SicRateTable extends OutlineElement {
  slots = new SlotsController(this);
  static styles: CSSResultGroup = [componentStyles];

  render(): TemplateResult {
    return html` <div class="full-table" tabindex="0">
      ${this.slots.conditionalSlot('heading')}
      ${this.slots.conditionalSlot('caption')}
      <div class="table-wrapper">
        ${this.slots.conditionalSlot('table', false)}
      </div>
    </div>`;
  }
}

declare global {
  interface HTMLElementTagNameMap {
    'sic-rate-table': SicRateTable;
  }
}
